import { Ed25519KeyIdentity } from '@icp-sdk/core/identity'
import { Secp256k1KeyIdentity } from '@icp-sdk/core/identity/secp256k1'
import { Principal } from '@icp-sdk/core/principal'
import Wallet from '../wallet'
import { IKeyChain, KeychainType } from './IKeychain'

export interface SerializedKeypairKeychain {
  type: KeychainType.KeyPairKeychain
  secretKey: string
  keyType?: string
}

const privates = new WeakMap<
  IKeyChain,
  {
    wallets: Array<{ wallet: Wallet; index: number }>
  }
>()

class KeyPairKeychain implements IKeyChain {
  type: KeychainType.KeyPairKeychain = KeychainType.KeyPairKeychain
  keyType?: string

  constructor() {
    privates.set(this, {
      wallets: [],
    })
  }

  async init(options: SerializedKeypairKeychain) {
    this.deserialize(options)
  }

  serialize(): Promise<SerializedKeypairKeychain> {
    return Promise.resolve({
      type: KeychainType.KeyPairKeychain,
      secretKey: JSON.stringify(privates.get(this)!.wallets[0].wallet.identity.toJSON()),
      keyType: this.keyType,
    })
  }

  deserialize(options: SerializedKeypairKeychain) {
    this.keyType = options.keyType

    if (this.keyType === 'ed25519') {
      const identity = Ed25519KeyIdentity.fromJSON(options.secretKey)
      privates.get(this)!.wallets = [{ wallet: new Wallet(0, identity), index: 0 }]
    } else {
      const identity = Secp256k1KeyIdentity.fromJSON(options.secretKey)
      privates.get(this)!.wallets = [{ wallet: new Wallet(0, identity), index: 0 }]
    }

    return Promise.resolve()
  }

  addNewAccount(): Promise<Wallet[]> {
    throw new Error('Method not implemented.')
  }

  getPrincipals(): Promise<Principal[]> {
    const _privates = privates.get(this)!
    const principals = _privates.wallets.map(({ wallet }) => wallet.principal)
    return Promise.resolve(principals)
  }

  getIdentity(principal: string) {
    const _privates = privates.get(this)!
    const wallet = _privates.wallets.find(
      (wallet) => wallet.wallet.principal.toString() === principal
    )
    if (!wallet) return Promise.reject('Unable to find wallet')

    return Promise.resolve(wallet.wallet.identity)
  }

  exportKeychain(): Promise<string> {
    throw new Error('Method not implemented.')
  }

  exportPem(principal: string): Promise<string> {
    throw new Error('Method not implemented.')
  }

  getSessionIdentity(): Promise<Secp256k1KeyIdentity | Ed25519KeyIdentity> {
    throw new Error('Method not implemented.')
  }

  clear() {
    privates.delete(this)
  }
}

export default KeyPairKeychain
